import axios from 'axios'
import apiConstant from './constant'
import { Message } from 'element-ui'
import Version from '../config/version'

axios.interceptors.response.use(res => {
  if (res && res.headers && res.headers['bloom-v']) {
    // 如果缓存存在
    if (localStorage.version) {
      if (localStorage.version !== res.headers['bloom-v']) {
        localStorage.setItem('version', res.headers['bloom-v'])
        console.log(localStorage.version)
        window.location.reload(true)
      }
    } else {
      // 没有缓存
      if (Version !== res.headers['bloom-v']) {
        localStorage.setItem('version', res.headers['bloom-v'])
        console.log(localStorage.version)
        window.location.reload(true)
      }
    }
  }
  return res
})
/**
 * 
 * @param {string} constant url常量字符串
 * @param {object} data 参数对象
 * @param {function} callback 回调函数
 * @param {function} errorCallback 返回码不为0时的回调函数
 * @param {function} catchCallback 断网或网络问题时回调函数
 */
export const post = (constant, data = {}, callback, errorCallback, catchCallback) => {
  // let loadingInstance = Loading.service({
  //   lock: true,
  //   text: 'Loading',
  //   spinner: 'el-icon-loading',
  //   background: 'rgba(0, 0, 0, 0.7)'
  // })
  let url = apiConstant[constant]
  url = '' + url
  axios.defaults.headers.post['Content-Type'] = 'application/json;charse=UTF-8'
  axios.defaults.headers.post['ctype'] = 3
  axios.post(
    url,
    JSON.stringify(data)
  ).then((res) => {
    // loadingInstance.close()
    if (res.data.code === 10016) {   // 登录过期或者未登录
      window.localStorage.setItem('userData', null)
      window.location.hash = '#/login'
    } else if (res.data.code === 30006) {
      typeof callback === 'function' && callback(res.data)
    } else if (res.data.code === 0) {
      typeof callback === 'function' && callback(res.data)
    } else if (res.data.code === 80000 || res.data.code === 80001 || res.data.code === 80002 || res.data.code === 80003) {
      typeof callback === 'function' && errorCallback(res.data)
    } else {
      Message({
        type: 'error',
        message: res.data.msg
      })
      typeof errorCallback === 'function' && errorCallback(res.data)
    }
  }).catch((error) => {
    // loadingInstance.close()
    typeof catchCallback === 'function' && catchCallback(error)
  })
}

export const purePost = (constant, data = {}, callback, errorCallback, catchCallback) => {
  // let loadingInstance = Loading.service({
  //   lock: true,
  //   text: 'Loading',
  //   spinner: 'el-icon-loading',
  //   background: 'rgba(0, 0, 0, 0.7)'
  // })
  let url = apiConstant[constant]
  url = '' + url
  axios.defaults.headers.post['Content-Type'] = 'application/json;charse=UTF-8'
  axios.defaults.headers.post['ctype'] = 3
  axios.post(
    url,
    JSON.stringify(data)
  ).then((res) => {
    // loadingInstance.close()
    if (res.data.code === 10016) {   // 登录过期或者未登录
      window.localStorage.setItem('userData', null)
      window.location.hash = '#/login'
    } else if (res.data.code === 10200) {
      typeof callback === 'function' && callback(res.data)
    } else if (res.data.code === 0) {
      typeof callback === 'function' && callback(res.data)
    } else {
      typeof errorCallback === 'function' && errorCallback(res.data)
    }
  }).catch((error) => {
    // loadingInstance.close()
    typeof catchCallback === 'function' && catchCallback(error)
  })
}

// 打包下载
export const getFile = url => {
  return new Promise((resolve, reject) => {
    axios.defaults.headers.get['Content-Type'] = 'application/json;charse=UTF-8'
    axios.defaults.headers.get['ctype'] = 3
    axios.defaults.headers.get['Access-Control-Allow-Origin'] = '*'
    axios.get(
      url,
      {responseType: 'arraybuffer'}
    ).then(data => {
      resolve(data.data)
    }).catch(error => {
      console.log(error)
      reject(error.toString())
    })
  })
}
// 水印下载
export const getFileWithWatermark = (constant, data = {}, callback, errorCallback, catchCallback) => {
  return new Promise((resolve, reject) => {
    let url = apiConstant[constant]
    url = '' + url
    axios.defaults.headers.post['Content-Type'] = 'application/json;charse=UTF-8'
    axios.defaults.headers.post['ctype'] = 3
    axios.get(
      url,
      {params: data, responseType: 'arraybuffer'}
    ).then((res) => {
      // console.log('postFile', res)
      resolve(res.data)
    }).catch((error) => {
      reject(error.toString())
    })
  })
}



// WEBPACK FOOTER //
// ./src/assets/api/index.js